export function clientCookies(
  name: string,
  value?: string
): string | undefined {
  if (typeof document === 'undefined') return;

  if (value) {
    document.cookie = `${name}=${value};path=/`;
  }

  const cookiesString = document.cookie;
  const cookies: Record<string, string> = cookiesString
    .split('; ')
    .reduce((acc, current) => {
      const [cookieName, cookieValue] = current.split('=');

      return {
        ...acc,
        [cookieName]: cookieValue,
      };
    }, {});

  return cookies[name];
}
